// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-matomo .md-form {\n  width: 100%;\n  margin-bottom: 0px !important;\n  margin-top: 0px !important;\n  margin-right: 20px;\n}\n\n", ""]);
// Exports
module.exports = exports;
